import {BaseConfig} from "../../infrastructure/config/base-config";
import {FilterBarModuleTerms} from "./filter-bar-module.terms";

export class FilterBarModuleConfig extends BaseConfig {

  static injectables = [FilterBarModuleTerms];

  constructor(terms: FilterBarModuleTerms){
    super('promotedSponsorshipModule', null, terms);
  }
}
